<template>
    <div class="invoices-view">
      <!-- Top bar -->
      <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
      </div>
      <div class="top-spacer"></div>
  
      <!-- Header -->
      <div class="panel-head">
        <h3>Maestro de facturas</h3>
        <img src="@/assets/filtros.png" alt="filtros" class="head-icon" />
      </div>
  
      <!-- Filters -->
      <form class="filters-card" @submit.prevent="queryOrders">
        <!-- Row: Invoice number range -->
        <div class="row">
          <label for="note_ident">Número de factura</label>
          <input type="text" id="note_ident" v-model="invoiceIdent" placeholder="Inicio" />
          <span class="sep">al</span>
          <input type="text" id="note_ident-end" v-model="invoiceIdentEnd" placeholder="Fin" />
        </div>
  
        <!-- Row: Billing date range -->
        <div class="row">
          <label>Fecha de facturación</label>
          <input type="date" v-model="startDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
          <span class="sep">al</span>
          <input type="date" v-model="endDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }"/>
        </div>
  
        <!-- Cliente (con sugerencias) -->
        <div class="row row-rel">
          <label for="client_name">Cliente</label>
          <input
            id="client_name"
            type="text"
            v-model="clientName"
            placeholder="Escriba para buscar"
            @input="filterSuggestions"
            autocomplete="off"
          />
          <div class="cell span-2"></div>
          <ul v-if="filteredClients.length" class="suggestions">
            <li v-for="(client, index) in filteredClients" :key="index" @click="selectClient(client)">
              {{ client.client_ident + ' - ' + client.client_name }}
            </li>
          </ul>
          <label for="client_name">Numero de cliente: {{ clientIdent }}</label>
        </div>
  
        <!-- Row: Series -->
        <div class="row">
          <label for="series">Serie</label>
          <select class="form-select" id="series" v-model="series" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
            <option value="NG">NG</option>
            <!-- <option value="A">A</option> -->
            <option value="NI">NI</option>
            <!-- <option value="B">B</option> -->
            <option value="NSN">NSN</option>
            <option value="NR">NR</option>
          </select>
          <div class="cell span-2"></div>
        </div>
  
        <!-- Secondary filter block -->
        <div class="row">
          <label for="orderNumber">Número de orden</label>
          <input type="text" id="orderNumber" v-model="noteIdent" placeholder="Inicio" />
          <span class="sep">al</span>
          <input type="text" id="orderNumberEnd" v-model="noteIdentEnd" placeholder="Fin" />
        </div>
  
        <div class="row">
          <label for="sucursal">Sucursal</label>
          <!-- <input type="text" id="sucursal" v-model="sucursal" placeholder="Sucursal" /> -->
          <select class="form-select" id="sucursal" v-model="sucursal" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
            <option v-for="opt in $catalogs.sucursales" :key="opt" :value="opt">{{ opt }}</option>
        </select>
        </div>
  
        <div class="row">
          <label for="engine">Serie del motor</label>
          <input type="text" id="engine" v-model="engine" placeholder="Serie" />
          <div class="cell span-2"></div>
        </div>
  
        <div class="row">
          <label for="balance">Saldo</label>
          <select class="form-select" id="balance" v-model="balance" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
            <option value="Pendiente">Pendiente</option>
            <option value="Pagado">Pagado</option>
          </select>
          <div class="cell span-2"></div>
        </div>
  
        <!-- Actions -->
        <div class="row actions">
          <div class="cell span-4">
            <button type="submit" class="btn-primary">Aplicar filtros</button>
          </div>
        </div>
      </form>
  
      <!-- Results -->
      <section class="results-card" id="results-section">
        <div v-if="!canViewTable" class="no-access">
          No tienes permisos para ver el listado de facturas.
        </div>
        <div class="results-head">
          <h2>Resultados: {{ totalCount }}</h2>
        </div>
  
        <div v-if="canViewTable" class="table-scroll">
          <table class="table">
            <thead>
  <tr>
    <th @click="toggleSort('invoice_ident')">
      ID
      <span v-if="isSorted('invoice_ident')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
      <span v-else>↕</span>
    </th>

    <th @click="toggleSort('date_issued')">
      Fecha
      <span v-if="isSorted('date_issued')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
      <span v-else>↕</span>
    </th>

    <th @click="toggleSort('client')">
      Cliente
      <span v-if="isSorted('client')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
      <span v-else>↕</span>
    </th>

    <th @click="toggleSort('note_number')">
      OT
      <span v-if="isSorted('note_number')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
      <span v-else>↕</span>
    </th>

    <th @click="toggleSort('amount')">
      Importe
      <span v-if="isSorted('amount')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
      <span v-else>↕</span>
    </th>

    <th @click="toggleSort('balance')">
      Saldo
      <span v-if="isSorted('balance')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
      <span v-else>↕</span>
    </th>

    <th @click="toggleSort('status')">
      Status
      <span v-if="isSorted('status')">{{ sortState.dir==='asc' ? '▲' : '▼' }}</span>
      <span v-else>↕</span>
    </th>

    <th>Archivos</th>
  </tr>
</thead>

            <tbody>
              <tr v-for="(order, index) in queriedOrders" :key="index">
                <!-- ID -->
                <td>
                  <span
                    class="badge badge-id"
                    @click="viewNoteDetails(order.type, order.note_ident, order.id, order.note_number, order.invoice_ident)"
                  >
                    {{ order.invoice_ident }}
                  </span>
                </td>
  
                <!-- Fecha/Hora stacked -->
                <td>
                  <b>Fecha:</b>
                  {{ order.date_issued.substring(8,10) }}/{{ order.date_issued.substring(5,7) }}/{{ order.date_issued.substring(0,4) }}
                  &nbsp;<b>Hora:</b> {{ order.date_issued.substring(11,16) }}
                </td>
  
                <!-- Cliente (compact with hover full) -->
                <td class="col-client" :title="order.client">
                  {{ shortClient(order.client) }}
                </td>
  
                <!-- OT -->
                <td class="col-ot">{{ order.note_number }}</td>
  
                <!-- Importe -->
                <td class="col-money">{{ formatMoney(Number(order.amount)) }}</td>
  
                <!-- Saldo -->
                <td class="col-money">{{ formatMoney(Number(order.balance)) }}</td>
  
                <!-- Status badge -->
                <td>
                  <span :class="['badge', statusBadgeClass(order)]">
                    {{ statusLabel(order) }}
                  </span>
                </td>
  
                <!-- Archivos (buttons) -->
                <td class="files-cell" @click.stop>
                  <button v-if="canGenerateXml" class="icon-btn" @click="downloadXML(order)" title="Descargar XML">📄</button>
                  <button v-if="canGeneratePdf" class="icon-btn" @click="downloadPDF(order)" title="Descargar PDF">🖨️</button>
                  <button v-if="canCancelInvoice" class="icon-btn" @click="cancelInvoice(order)" title="Cancelar factura">🚫</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
  
        <!-- Pagination -->
        <div v-if="canViewTable" class="pagination">
          <button @click="prevPage" :disabled="currentPage === 1" class="pg-btn" aria-label="Página anterior">
            <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
          </button>
          <span
            v-for="pageNumber in TotalPages"
            :key="pageNumber"
            @click="goToPage(pageNumber)"
            :class="['pg-num', { active: pageNumber === currentPage }]"
          >
            {{ pageNumber }}
          </span>
          <button @click="nextPage" :disabled="currentPage >= TotalPages" class="pg-btn" aria-label="Página siguiente">
            <img src="@/assets/angulo-derecho.png" alt="Next Page" />
          </button>
        </div>
      </section>
  
      <!-- Cancel popup -->
      <div v-if="showPopup" class="popup-overlay" @click="closePopup">
        <div class="popup-content" @click.stop>
          <div class="popup-header">
            <div class="popup-header-left">
              <p><strong>¿Seguro que quiere cancelar?</strong></p>
            </div>
          </div>
          <div class="popup-body">
            <div class="form-group-filters">
              <strong>Factura #</strong> {{ invoice_ident }}
            </div>
            <div class="form-group-filters">
              <label for="cancellation_reason">Motivo de cancelación: </label>
              <select id="cancellation_reason" v-model="cancellation_reason" class="form-select">
                <option value="02">Comprobante emitido con errores sin relación</option>
              </select>
            </div>
          </div>
          <button class="popup-close-button" @click="SATcancelInvoice">Cancelar factura</button>
          <button class="popup-close-button" @click="closePopup">Cerrar</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import Swal from 'sweetalert2';
  import Fuse from 'fuse.js';
  
  export default {
    name: "OrdersTableView",
    data() {
      return {
        permissions: [],
        invoiceIdent: '',
        invoiceIdentEnd: '',
        noteIdent: '',
        noteIdentEnd: '',
        startDate: '',
        endDate: '',
        clientName: '',
        series: '',
        sucursal: '',
        engine: '',
        queriedOrders: [],
        currentPage: 1,
        pageSize: 20,
        nOrders: 1,
        StatusCounts: { Contado: 1, Credito: 1 },
        clients: [],
        filteredClients: [],
        fuse: null,
        totalCount: 0,
        payload: {},
        localNoteDetails: {},
        balance: '',
        showPopup: false,
        invoice_ident: '',
        cancellation_reason: '02',
        invoice: [],
        invoice_id: '',
        blockEdit: false,
        clientIdent: '',
        username: '',
      firstName: '',
      lastName: '',
      sortState: { by: 'date_issued', dir: 'desc' },
      groups: [],
      };
    },
    computed: {
      canAccessInvoiceMaster() {
        return this.hasAnyPerm(['accounting.view_invoice_master'])
      },
      canViewTable() {
        return this.hasAnyPerm(['accounting.view_invoice_table'])
      },
      canViewInvoice() {
        return this.hasAnyPerm(['accounting.view_invoice_detail'])
      },
      canGenerateXml() {
        return this.hasAnyPerm(['accounting.generate_invoice_xml'])
      },
      canGeneratePdf() {
        return this.hasAnyPerm(['accounting.generate_invoice_pdf'])
      },
      canCancelInvoice() {
        return this.hasAnyPerm(['accounting.cancel_invoice'])
      },
      effectiveEndDate() {
        return this.endDate || this.startDate;
      },
      PaginatedOrders() {
        return this.queriedOrders;
      },
      TotalPages() {
        return Math.ceil((this.StatusCounts.Contado + this.StatusCounts.Credito) / this.pageSize);
      },
    },
    created() {
      this.loadPermissions()
      this.fetchCurrentUser()
    },
    methods: {
      loadPermissions() {
        try {
          this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
        } catch (error) {
          this.permissions = []
        }
      },
      hasPerm(perm) {
        if (!perm) return false
        if (this.permissions.includes(perm)) return true
        return this.permissions.includes(`access_control.${perm}`)
      },
      hasAnyPerm(perms) {
        if (!Array.isArray(perms) || perms.length === 0) return false
        return perms.some((perm) => this.hasPerm(perm))
      },
      formatMoney(value) {
    const n = Number(value);
    if (!isFinite(n)) return value ?? '';        // leave as-is if not a number
    return new Intl.NumberFormat('en-US', {      // comma thousands, dot decimals
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(n);
  },
      orderingParam() {
    const { by, dir } = this.sortState || {};
    if (!by) return '';
    return (dir === 'desc' ? '-' : '') + by;
  },
  isSorted(field) {
    return this.sortState?.by === field;
  },
  toggleSort(field) {
    if (!this.sortState) this.sortState = { by: field, dir: 'asc' };
    else if (this.sortState.by === field) {
      this.sortState.dir = this.sortState.dir === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.by = field;
      this.sortState.dir = 'asc';
    }
    // when the sort changes, go back to page 1 and re-query
    this.currentPage = 1;
    this.queryOrders();
  },
      async fetchCurrentUser() {
      const apiDirectory = process.env.API_DIRECTORY
      this.loading = true
      this.error = null
      try {
        const { data } = await axios.get(`${apiDirectory}/current-user/`, {
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.username = data.username
        this.firstName = data.first_name
        this.lastName = data.last_name
        this.groups = data.groups || []
      } catch (err) {
        console.error('Error fetching user:', err)
        this.error = 'No se pudo cargar la información del usuario.'
      } finally {
        this.loading = false
      }
    },
      // --- Tiny Helpers for compact display ---
      shortClient(name) {
        const s = String(name || '');
        return s.length > 24 ? s.slice(0, 23) + '…' : s;
      },
      statusLabel(order) {
        if (order?.is_cancelled === true) return 'Cancelado';
        if (Number(order?.balance) <= 0) return 'Pagado';
        return 'Pendiente';
      },
      statusBadgeClass(order) {
        if (order?.is_cancelled === true) return 'badge-danger';
        if (Number(order?.balance) <= 0) return 'badge-success';
        return 'badge-warn';
      },
  
      // --- Existing methods (unchanged endpoints/logic) ---
      formatToDatetime(date, time) { return date ? `${date}T${time}` : ''; },
  
      async fetchClients() {
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/get-privileged-clients`);
          this.clients = response.data;
          this.initializeFuse();
        } catch (error) { console.error('Error fetching clients:', error); }
      },
      initializeFuse() {
        const options = { keys: ['client_name'], threshold: 0.3, ignoreLocation: true, includeScore: false };
        this.fuse = new Fuse(this.clients, options);
      },
      filterSuggestions() {
          const searchTerm = this.clientName.toLowerCase().trim();

          if (searchTerm === '') {
              this.filteredClients = [];
              this.highlightedIndex = -1;
              return;
          }

          this.filteredClients = this.clients.filter(client => {
              return (
                  client.client_name.toLowerCase().includes(searchTerm) ||
                  client.client_ident.toLowerCase().includes(searchTerm)
              );
          });

          this.highlightedIndex = -1;
      },

      selectClient(client) { this.clientName = client.client_name; this.clientIdent = client.client_ident; this.filteredClients = []; },
  
      backMainPanel() { window.location.href = '/main-panel'; },
      viewNoteDetails(notetype, noteID, invoiceID, noteNumber, invoiceIdent) {
        if (!this.canViewInvoice) {
          Swal.fire('Sin acceso', 'No tienes permisos para ver la factura.', 'warning')
          return
        }
        this.$router.push({ name: 'EditInvoice', params: { notetype, noteID, invoiceID, noteNumber, invoiceIdent } });
      },
  
      goToPage(pageNumber) { this.currentPage = pageNumber; this.queryOrders(this.currentPage); },
      nextPage() { if (this.currentPage < this.TotalPages) this.currentPage++; this.queryOrders(this.currentPage); },
      prevPage() { if (this.currentPage > 1) this.currentPage--; this.queryOrders(this.currentPage); },
  
      async fetchStatistics(){
        if (!this.canViewTable) {
          return
        }
        const payload = {
          invoice_ident: this.invoiceIdent,
          invoice_ident_end: this.invoiceIdentEnd, 
          note_ident: this.noteIdent,
          note_ident_end: this.noteIdentEnd,
          start_date: this.formatToDatetime(this.startDate, '00:00'),
          end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
          client_name: this.clientName || "",
          series: this.series,
          sucursal: this.sucursal,
          engine: this.engine,
          balance: this.balance,
          client_ident: this.clientName === "" ? "" : this.clientIdent,
        };
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.post(`${apiDirectory}/get-global-filtered-invoice-statistics`, payload);
          let statusCounts = { Contado: 0, Credito: 0 };
          this.totalCount = 0;
          (response.data || []).forEach(item => {
            const status = item.invoice_type;
            const count = item.count;
            statusCounts[status] = count;
            this.totalCount += count;
          });
          this.StatusCounts = statusCounts;
        } catch (error) {
          console.error("There was an error fetching the statistics", error);
        }
      },
  
      async queryOrders(){
        if (!this.canViewTable) {
          Swal.fire('Sin acceso', 'No tienes permisos para ver facturas.', 'warning')
          return
        }
        this.fetchStatistics();
        const payload = {
          invoice_ident: this.invoiceIdent,
          invoice_ident_end: this.invoiceIdentEnd, 
          note_ident: this.noteIdent,
          note_ident_end: this.noteIdentEnd,
          start_date: this.formatToDatetime(this.startDate, '00:00'),
          end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
          client_name: this.clientName || "",
          series: this.series,
          sucursal: this.sucursal,
          engine: this.engine,
          balance: this.balance,
          client_ident: this.clientName === "" ? "" : this.clientIdent,
        };
        const ordering = this.orderingParam();
  const orderingQS = ordering ? `&ordering=${encodeURIComponent(ordering)}` : '';
        try {
          const apiDirectory = process.env.API_DIRECTORY;
    const url = `${apiDirectory}/get-global-filtered-invoices?page=${this.currentPage}&page_size=${this.pageSize}${orderingQS}`;
    const response = await axios.post(url, payload);
          const results = (response.data && response.data.results) ? response.data.results : [];
          results.forEach(order => {
            if (!('contact_time' in order) || order.contact_time === null) order.contact_time = '';
            if (!('start_time' in order) || order.start_time === null) order.start_time = '';
            if (!('unit_id' in order) || order.unit_id === null) order.unit_id = 'N/A';
            if (!('operator_first_name' in order) || order.operator_first_name === null) order.operator_first_name = 'N/A';
            if (!('operator_employee_ident' in order) || order.operator_employee_ident === null) order.operator_employee_ident = 'N/A';
          });
          this.queriedOrders = results;
        } catch (error) {
          const errorMessage = error.response ? (error.response.data.error || JSON.stringify(error.response.data)) : error.message;
          Swal.fire({ icon: 'error', title: 'Error Generando Reporte', text: errorMessage });
        }
  
        // 👉 Auto-scroll to results
        this.$nextTick(() => {
          const el = document.getElementById('results-section');
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      },
  
      // (unchanged) downloads & cancellation flow
      async downloadXML(invoice){
        if (!this.canGenerateXml) {
          Swal.fire('Sin acceso', 'No tienes permisos para descargar XML.', 'warning')
          return
        }
        const invoiceNumber = invoice.invoice_number;
        const signedXML = invoice.xml;
        const apiDirectory = process.env.API_DIRECTORY;
        axios.post(`${apiDirectory}/generate-invoice-xml`, { signedXML, invoice_number: invoiceNumber }, { responseType: 'blob' })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url; link.setAttribute('download', `factura_${invoiceNumber}.xml`);
            document.body.appendChild(link); link.click(); link.remove();
          })
          .catch(error => { console.error('Error generating files', error) });
      },
  
      async downloadPDF(invoice) {
        if (!this.canGeneratePdf) {
          Swal.fire('Sin acceso', 'No tienes permisos para descargar PDF.', 'warning')
          return
        }
        // (kept identical to your logic; minor formatting only)
        const invoiceNumber = invoice.invoice_number;
        const signedXML = invoice.xml;
        const apiDirectory = process.env.API_DIRECTORY;
        const vectorNoteID = invoice.note_ident.split('-');
        const assignationsResponse = await axios.post(`${apiDirectory}/get-note-assignations`, {note_ident: invoice.note_ident});
        const assignationsData = assignationsResponse.data;
        const firstAssignation = assignationsData[0];
  
        try {
          const response = await axios.get(`${apiDirectory}/notes/${invoice.note_ident}/`);
          this.localNoteDetails = response.data;
  
          let responseBrand = null;
          if (this.localNoteDetails.vehicle_sub_brand) {
            try {
              responseBrand = await axios.post(`${apiDirectory}/get-sub-brand`, {
                sub_brand_id: this.localNoteDetails.vehicle_sub_brand
              });
            } catch (err) { console.warn("Could not fetch sub-brand:", err); }
          }
  
          if (invoice.note_number === 'VARIAS') {
            const pdfResponse = await axios.post(
              `${apiDirectory}/generate-invoice-pdf`,
              {
                signedXML,
                plh_operatorName: 'VARIAS',
                plh_orderId: 'VARIAS',
                plh_insurancePolicy: 'VARIOS',
                plh_totalTime: '0.0',
                plh_discount: '0.00',
                note_type: vectorNoteID[0],
                invoice_number: invoiceNumber,
                plh_series: this.localNoteDetails.invoice_detail.invoice_series,
                plh_maneuver: this.localNoteDetails?.maneuver_to_perform ?? '',
                plh_serviceDescription: this.localNoteDetails?.source_notes ?? '',
                plh_total: this.localNoteDetails.total,
                plh_subtotal: this.localNoteDetails.subtotal,
                plh_retention: this.localNoteDetails.retention,
                plh_iva: this.localNoteDetails.iva,
                plh_client_name: invoice.client
              },
              { responseType: 'blob' }
            );
            const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
            const link = document.createElement('a');
            link.href = url; link.setAttribute('download', `factura_${invoiceNumber}.pdf`);
            document.body.appendChild(link); link.click(); link.remove();
            return;
          }
  
          const dateDifferenceHours = Math.ceil(
            Math.abs(new Date(firstAssignation.end_time) - new Date(firstAssignation.start_time)) / (1000 * 60 * 60)
          );

          if(this.localNoteDetails.invoice_detail.invoice_series === 'NSN' || this.localNoteDetails.invoice_detail.invoice_series === 'SN')
            this.payload = {
              signedXML,
              plh_authorize: this.localNoteDetails?.approved_by ?? '',
              plh_operatorName: (this.localNoteDetails.invoice_detail.invoice_series === 'NSN' || 
                            this.localNoteDetails.invoice_detail.invoice_series === 'SN' || 
                            this.client_rfc === 'XEXX010101000' || 
                            this.client_rfc === 'XAXX010101000')
                                ? ''
                                : `${firstAssignation?.operator?.employee_first_name ?? ''} ${firstAssignation?.operator?.employee_last_name ?? ''}`.trim(),
              plh_operatorNumber: (this.localNoteDetails.invoice_detail.invoice_series === 'NSN' || 
                            this.localNoteDetails.invoice_detail.invoice_series === 'SN' || 
                            this.client_rfc === 'XEXX010101000' || 
                            this.client_rfc === 'XAXX010101000')
                                ? ''
                                :firstAssignation?.operator?.employee_ident ?? '',
              plh_orderId: this.localNoteDetails?.note_number ?? '',
              plh_unitNumber: (this.localNoteDetails.invoice_detail.invoice_series === 'NSN' || 
                            this.localNoteDetails.invoice_detail.invoice_series === 'SN' || 
                            this.client_rfc === 'XEXX010101000' || 
                            this.client_rfc === 'XAXX010101000')
                                ? ''
                                : firstAssignation?.unit?.unit_short_id ?? '',
              plh_plates: this.localNoteDetails?.vehicle_plates ?? '',
              plh_vehicleBrand: (this.localNoteDetails.invoice_detail.invoice_series === 'NSN' || 
                                          this.localNoteDetails.invoice_detail.invoice_series === 'SN' || 
                                          this.client_rfc === 'XEXX010101000' || 
                                          this.client_rfc === 'XAXX010101000')
                                              ? ''
                                              : responseBrand ? `${responseBrand.data?.brand ?? ''} ${responseBrand.data?.sub_brand ?? ''}`.trim() : '',
              plh_vehicleModel: (this.localNoteDetails.invoice_detail.invoice_series === 'NSN' || 
                                          this.localNoteDetails.invoice_detail.invoice_series === 'SN' || 
                                          this.client_rfc === 'XEXX010101000' || 
                                          this.client_rfc === 'XAXX010101000')
                                              ? ''
                                              : `${this.localNoteDetails?.vehicle_model ?? ''} ${this.localNoteDetails?.vehicle_color ?? ''}`.trim(),
              plh_niv: this.localNoteDetails?.vehicle_engine_series ?? '',
              plh_insuredName: this.localNoteDetails?.vehicle_owner_name ?? '',
              plh_record: this.localNoteDetails?.file_number ?? '',
              plh_insurancePolicy: this.localNoteDetails?.insurance_policy ?? '',
              plh_destination: this.localNoteDetails?.destination
                ? `${this.localNoteDetails.destination?.neighborhood ?? ''}, ${this.localNoteDetails.destination?.city ?? ''} ${this.localNoteDetails.destination?.state ?? ''}`.trim()
                : '',
              plh_origin: this.localNoteDetails?.source
                ? `${this.localNoteDetails.source?.neighborhood ?? ''}, ${this.localNoteDetails.source?.city ?? ''} ${this.localNoteDetails.source?.state ?? ''}`.trim()
                : '',
              plh_serviceDescription: this.localNoteDetails?.source_notes ?? '',
              plh_startTime: firstAssignation?.start_time ? firstAssignation.start_time.slice(0, 16).replace("T", " ") : '',
              plh_arrivalTime: firstAssignation?.arrival_time ? firstAssignation.arrival_time.slice(0, 16).replace("T", " ") : '',
              plh_endTime: firstAssignation?.end_time ? firstAssignation.end_time.slice(0, 16).replace("T", " ") : '',
              plh_totalTime: dateDifferenceHours ?? '',
              plh_discount: '0.00',
              note_type: 'ASV',
              invoice_number: invoiceNumber ?? '',
              plh_series: this.localNoteDetails?.invoice_detail?.invoice_series ?? '',
              plh_total: this.localNoteDetails?.total ?? '',
              plh_subtotal: this.localNoteDetails?.subtotal ?? '',
              plh_retention: this.localNoteDetails?.retention ?? '',
              plh_iva: this.localNoteDetails?.iva ?? '',
              plh_client_name: invoice?.client ?? ''
            };
  
          else if (vectorNoteID[0] === 'ASV') {
            this.payload = {
              signedXML,
              plh_authorize: this.localNoteDetails?.approved_by ?? '',
              plh_operatorName: `${firstAssignation?.operator?.employee_first_name ?? ''} ${firstAssignation?.operator?.employee_last_name ?? ''}`.trim(),
              plh_operatorNumber: firstAssignation?.operator?.employee_ident ?? '',
              plh_orderId: this.localNoteDetails?.note_number ?? '',
              plh_unitNumber: firstAssignation?.unit?.unit_short_id ?? '',
              plh_plates: this.localNoteDetails?.vehicle_plates ?? '',
              plh_vehicleBrand: responseBrand ? `${responseBrand.data?.brand ?? ''} ${responseBrand.data?.sub_brand ?? ''}`.trim() : '',
              plh_vehicleModel: `${this.localNoteDetails?.vehicle_model ?? ''} ${this.localNoteDetails?.vehicle_color ?? ''}`.trim(),
              plh_niv: this.localNoteDetails?.vehicle_engine_series ?? '',
              plh_insuredName: this.localNoteDetails?.vehicle_owner_name ?? '',
              plh_record: this.localNoteDetails?.file_number ?? '',
              plh_insurancePolicy: this.localNoteDetails?.insurance_policy ?? '',
              plh_destination: this.localNoteDetails?.destination
                ? `${this.localNoteDetails.destination?.neighborhood ?? ''}, ${this.localNoteDetails.destination?.city ?? ''} ${this.localNoteDetails.destination?.state ?? ''}`.trim()
                : '',
              plh_origin: this.localNoteDetails?.source
                ? `${this.localNoteDetails.source?.neighborhood ?? ''}, ${this.localNoteDetails.source?.city ?? ''} ${this.localNoteDetails.source?.state ?? ''}`.trim()
                : '',
              plh_serviceDescription: this.localNoteDetails?.source_notes ?? '',
              plh_startTime: firstAssignation?.start_time ? firstAssignation.start_time.slice(0, 16).replace("T", " ") : '',
              plh_arrivalTime: firstAssignation?.arrival_time ? firstAssignation.arrival_time.slice(0, 16).replace("T", " ") : '',
              plh_endTime: firstAssignation?.end_time ? firstAssignation.end_time.slice(0, 16).replace("T", " ") : '',
              plh_totalTime: dateDifferenceHours ?? '',
              plh_discount: '0.00',
              note_type: 'ASV',
              invoice_number: invoiceNumber ?? '',
              plh_series: this.localNoteDetails?.invoice_detail?.invoice_series ?? '',
              plh_total: this.localNoteDetails?.total ?? '',
              plh_subtotal: this.localNoteDetails?.subtotal ?? '',
              plh_retention: this.localNoteDetails?.retention ?? '',
              plh_iva: this.localNoteDetails?.iva ?? '',
              plh_client_name: invoice?.client ?? ''
            };
          } else if (vectorNoteID[0] === 'AUX') {
            this.payload = {
              signedXML,
              plh_authorize: this.localNoteDetails?.approved_by ?? '',
              plh_operatorName: `${firstAssignation?.operator?.employee_first_name ?? ''} ${firstAssignation?.operator?.employee_last_name ?? ''}`.trim(),
              plh_operatorNumber: firstAssignation?.operator?.employee_ident ?? '',
              plh_orderId: this.localNoteDetails?.note_number ?? '',
              plh_unitNumber: firstAssignation?.unit?.unit_short_id ?? '',
              plh_plates: this.localNoteDetails?.vehicle_plates ?? '',
              plh_vehicleBrand: `${this.selectedBrandId ?? ''} ${this.selectedSubBrandId ?? ''}`.trim(),
              plh_vehicleModel: `${this.localNoteDetails?.vehicle_model ?? ''} ${this.localNoteDetails?.vehicle_color ?? ''}`.trim(),
              plh_niv: this.localNoteDetails?.vehicle_engine_series ?? '',
              plh_insuredName: this.localNoteDetails?.vehicle_owner_name ?? '',
              plh_record: this.localNoteDetails?.file_number ?? '',
              plh_insurancePolicy: this.localNoteDetails?.insurance_policy ?? '',
              plh_event: this.localNoteDetails?.insurance_incident ?? '',
              plh_origin: this.localNoteDetails?.source
                ? `${this.localNoteDetails.source?.neighborhood ?? ''}, ${this.localNoteDetails.source?.city ?? ''} ${this.localNoteDetails.source?.state ?? ''}`.trim()
                : '',
              plh_serviceDescription: this.localNoteDetails?.aux_requested_service ?? '',
              plh_startTime: firstAssignation?.start_time ? firstAssignation.start_time.slice(0, 16).replace("T", " ") : '',
              plh_arrivalTime: firstAssignation?.arrival_time ? firstAssignation.arrival_time.slice(0, 16).replace("T", " ") : '',
              plh_endTime: firstAssignation?.end_time ? firstAssignation.end_time.slice(0, 16).replace("T", " ") : '',
              plh_totalTime: dateDifferenceHours ?? '',
              plh_discount: '0.00',
              note_type: 'AUX',
              invoice_number: invoiceNumber ?? '',
              plh_series: this.localNoteDetails?.invoice_detail?.invoice_series ?? '',
              plh_total: this.localNoteDetails?.total ?? '0.00',
              plh_subtotal: this.localNoteDetails?.subtotal ?? '0.00',
              plh_retention: this.localNoteDetails?.retention ?? '0.00',
              plh_iva: this.localNoteDetails?.iva ?? '0.00',
              plh_client_name: invoice?.client ?? ''
            };
          } else if (vectorNoteID[0] === 'MTC' || vectorNoteID[0] === 'IND') {
            this.payload = {
              signedXML,
              plh_authorize: this.localNoteDetails?.approved_by ?? '',
              plh_operatorName: `${firstAssignation?.operator?.employee_first_name ?? ''} ${firstAssignation?.operator?.employee_last_name ?? ''}`.trim(),
              plh_operatorNumber: firstAssignation?.operator?.employee_ident ?? '',
              plh_orderId: this.localNoteDetails?.note_number ?? '',
              plh_unitNumber: firstAssignation?.unit?.unit_short_id ?? '',
              plh_plates: this.localNoteDetails?.vehicle_plates ?? '',
              plh_vehicleBrand: `${this.selectedBrandId ?? ''} ${this.selectedSubBrandId ?? ''}`.trim(),
              plh_vehicleModel: `${this.localNoteDetails?.vehicle_model ?? ''} ${this.localNoteDetails?.vehicle_color ?? ''}`.trim(),
              plh_niv: this.localNoteDetails?.vehicle_engine_series ?? '',
              plh_insuredName: 'No disponible', // forced default
              plh_record: this.localNoteDetails?.file_number ?? '',
              plh_insurancePolicy: 'No disponible', // forced default
              plh_maneuver: this.localNoteDetails?.maneuver_to_perform ?? '',
              // plh_origin: this.localNoteDetails?.source
              //   ? `${this.localNoteDetails.source?.neighborhood ?? ''}, ${this.localNoteDetails.source?.city ?? ''} ${this.localNoteDetails.source?.state ?? ''}`.trim()
              //   : '',
              plh_serviceDescription: this.localNoteDetails?.source_notes ?? '',
              plh_startTime: firstAssignation?.start_time ? firstAssignation.start_time.slice(0, 16).replace("T", " ") : '',
              plh_arrivalTime: firstAssignation?.arrival_time ? firstAssignation.arrival_time.slice(0, 16).replace("T", " ") : '',
              plh_endTime: firstAssignation?.end_time ? firstAssignation.end_time.slice(0, 16).replace("T", " ") : '',
              plh_totalTime: dateDifferenceHours ?? '',
              plh_discount: '0.00',
              note_type: vectorNoteID[0],
              invoice_number: invoiceNumber ?? '',
              plh_series: this.localNoteDetails?.invoice_detail?.invoice_series ?? '',
              plh_total: this.localNoteDetails?.total ?? '0.00',
              plh_subtotal: this.localNoteDetails?.subtotal ?? '0.00',
              plh_retention: this.localNoteDetails?.retention ?? '0.00',
              plh_iva: this.localNoteDetails?.iva ?? '0.00',
              plh_client_name: invoice?.client ?? ''
            };
          } else if (vectorNoteID[0] === 'LOT') {
            this.payload = {
              signedXML,
              plh_authorize: this.localNoteDetails?.approved_by ?? '',
              plh_operatorName: `${firstAssignation?.operator?.employee_first_name ?? ''} ${firstAssignation?.operator?.employee_last_name ?? ''}`.trim(),
              plh_operatorNumber: firstAssignation?.operator?.employee_ident ?? '',
              plh_orderId: this.localNoteDetails?.note_number ?? '',
              plh_unitNumber: firstAssignation?.unit?.unit_short_id ?? '',
              plh_plates: this.localNoteDetails?.vehicle_plates ?? '',
              plh_vehicleBrand: `${this.selectedBrandId ?? ''} ${this.selectedSubBrandId ?? ''}`.trim(),
              plh_vehicleModel: `${this.localNoteDetails?.vehicle_model ?? ''} ${this.localNoteDetails?.vehicle_color ?? ''}`.trim(),
              plh_niv: this.localNoteDetails?.vehicle_engine_series ?? '',
              plh_insuredName: this.localNoteDetails?.vehicle_owner_name ?? '',
              plh_record: this.localNoteDetails?.file_number ?? '',
              plh_insurancePolicy: this.localNoteDetails?.insurance_policy ?? '',
              plh_lot: this.localNoteDetails?.lot ?? '',
              plh_origin: `${this.localNoteDetails?.source?.neighborhood ?? ''}, ${this.localNoteDetails?.source?.city ?? ''} ${this.localNoteDetails?.source?.state ?? ''}`.trim(),
              plh_detentionDescription: this.localNoteDetails?.lot_retention ?? '',
              plh_authority: this.localNoteDetails?.lot_authority ?? '',
              plh_arrivalTime: this.localNoteDetails?.lot_start_time?.slice(0, 16).replace("T", " ") ?? '',
              plh_endTime: this.localNoteDetails?.lot_end_time?.slice(0, 16).replace("T", " ") ?? '',
              plh_totalTime: dateDifferenceHours ?? '0.00',
              plh_discount: '0.00',
              note_type: 'LOT',
              invoice_number: invoiceNumber ?? '',
              plh_series: this.localNoteDetails?.invoice_detail?.invoice_series ?? '',
              plh_total: this.localNoteDetails?.total ?? '0.00',
              plh_subtotal: this.localNoteDetails?.subtotal ?? '0.00',
              plh_retention: this.localNoteDetails?.retention ?? '0.00',
              plh_iva: this.localNoteDetails?.iva ?? '0.00',
              plh_client_name: invoice?.client ?? ''
            };
          }
  
          const pdfResponse = await axios.post(`${apiDirectory}/generate-invoice-pdf`, this.payload, { responseType: 'blob' });
          const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
          const link = document.createElement('a');
          link.href = url; link.setAttribute('download', `factura_${invoiceNumber}.pdf`);
          document.body.appendChild(link); link.click(); link.remove();
  
        } catch (error) { console.error("Error generating files", error); }
      },
  
      async cancelInvoice(invoice){
        if (!this.canCancelInvoice) {
          Swal.fire('Sin acceso', 'No tienes permisos para cancelar la factura.', 'warning')
          return
        }
        const apiDirectory = process.env.API_DIRECTORY;
        this.invoice_ident = invoice.invoice_ident;
        const invoiceId = invoice.id;
        const transactionsResponse = await axios.post(`${apiDirectory}/get-invoice-transactions`, { invoice_ident: invoiceId });
        const othertransactions = transactionsResponse.data.filter(t => t.transaction_type.id !== 8 && t.transaction_type.id !== 1);
        this.invoice = invoice;
  
        if (this.invoice?.is_cancelled === true) {
          Swal.fire({ icon: 'error', title: 'Error al Cancelar Factura', text: 'La factura ya está cancelada' });
        } else if (othertransactions.length === 0) {
          this.showPopup = true;
        } else if (othertransactions.length !== 0) {
          Swal.fire({ icon: 'error', title: 'Error al Cancelar Factura', text: 'Hay pagos que no han sido eliminados' });
        } else {
          Swal.fire({ icon: 'error', title: 'Ha ocurrido un error', text: 'Por favor intente nuevamente.' });
        }
      },
      closePopup() { this.showPopup = false; },
      async SATcancelInvoice() {
        this.showPopup = false;
        const invoice_xml = this.invoice.xml;
        const apiDirectory = process.env.API_DIRECTORY;
        try {
          const parser = new DOMParser();
          
          const xmlDoc = parser.parseFromString(invoice_xml, "text/xml");
          const timbreNode = xmlDoc.getElementsByTagName("tfd:TimbreFiscalDigital")[0];
          if (!timbreNode) { console.error("No se encontró el nodo TimbreFiscalDigital en el XML"); return null; }
          const uuid_extract = timbreNode.getAttribute("UUID");
          const response = await axios.post(`${apiDirectory}/cancel-invoice`, {uuid: uuid_extract, cancel_reason: this.cancellation_reason});
          const cleanedXml = response.data.replace(/[\r\n]+/g, '').trim();
  
          const linkedNotes = await axios.post(`${apiDirectory}/get-invoice-notes-list`, {invoice_id: this.invoice.id});
          const noteIDs = Object.values(linkedNotes.data);
          await Promise.all(noteIDs.map(noteID => axios.patch(`${apiDirectory}/notes/${noteID}/`, {invoice: null, status: 4}) ));
  
          // await axios.patch(`${apiDirectory}/update-invoice/${this.invoice_ident}/`, {
          //   is_cancelled: true,
          //   cancelled_xml: cleanedXml
          // });
  
          await axios.post(`${apiDirectory}/set-invoice-transactions`, [{
            transaction_ident: '',
            invoice: this.invoice.id,
            amount: this.invoice.balance,
            reference: '',
            transaction_type: 8,
            transaction_date: new Date().toISOString(),
            origin_bank_account: '',
            destination_bank_account: '',
            bank: '',
            payment_method: '',
            cfdi_comments: '',
            observations: '',
          }]);

          const balanceNumber = await axios.post(`${apiDirectory}/calculate-invoice-balance`, { invoice_ident: this.invoice.id });
          await axios.put(`${apiDirectory}/update-invoice/${this.invoice.invoice_ident}/`, {balance: Number(balanceNumber.data), 
                                                                                            is_cancelled: true,
                                                                                            cancelled_xml: cleanedXml
                                                                                           }); 
  
          Swal.fire({ icon: 'success', title: 'Factura Cancelada', text: 'La factura ha sido cancelada correctamente.' });
          this.queryOrders();
  
        } catch (error) {
          const errorMessage = error.response ? (error.response.data.error || JSON.stringify(error.response.data)) : error.message;
          Swal.fire({ icon: 'error', title: 'Error al Cancelar Factura', text: errorMessage });
          console.error("Error cancelling invoice:", errorMessage);
        }
      },
    },
    mounted() {
      if (!this.canAccessInvoiceMaster) {
        Swal.fire('Sin acceso', 'No tienes permisos para ver el maestro de facturas.', 'warning')
        this.$router.push({ path: '/main-panel' })
        return
      }
      this.fetchClients();
    }
  };
  </script>
  
  <style scoped>

   /* Make the table slightly denser and fix column widths */
.table {
  table-layout: fixed;          /* respect explicit widths */
  font-size: 11px;              /* down from 12px */
}
.table thead th { 
  font-size: 11.5px;
  padding: 5px 6px;             /* a touch tighter */
}
.table tbody td {
  padding: 4px 6px;             /* a touch tighter */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Narrow the wordiest columns */
.col-client      { max-width: 160px; width: 160px; }
.col-origin      { max-width: 180px; width: 180px; }
.col-destination { max-width: 180px; width: 180px; }

/* Slightly tighten other cells so everything fits */
.table td:nth-child(1)  { width: 84px;  }  /* ID (badge) */
.table td:nth-child(2)  { width: 170px; }  /* Fecha y hora */
.table td:nth-child(6)  { width: 92px;  }  /* Hora inicio */
.table td:nth-child(7)  { width: 110px; }  /* Hora contacto */
.table td:nth-child(8)  { width: 80px;  }  /* Unidad */
.table td:nth-child(9)  { width: 110px; }  /* Operador */
.table td:nth-child(10) { width: 110px; }  /* Expediente */
.table td:nth-child(11) { width: 120px; }  /* Capturista */
.table td:nth-child(12) { width: 90px;  }  /* Tipo */
.table td:nth-child(13) { width: 110px; }  /* Estatus */

/* On slightly smaller screens, compress client/address a bit more */
@media (max-width: 1360px) {
  .col-client      { max-width: 140px; width: 140px; }
  .col-origin,
  .col-destination { max-width: 160px; width: 160px; }
}

/* On tighter layouts, shave a bit of font size and padding */
@media (max-width: 1200px) {
  .table { font-size: 10.5px; }
  .table thead th { font-size: 11px; }
  .table tbody td { padding: 3px 5px; }
}
  /* Design tokens */
  :root {
    --brand: #ffc434;
    --brand-600: #e6b12e;
    --bg: #f7f7f8;
    --card: #ffffff;
    --border: #e8e8ea;
    --muted: #70737a;
    --text: #1f2328;
  
    --success: #28a745;
    --danger: #e5484d;
    --warn: #f59e0b;
  
    --radius-sm: 6px;
    --radius-md: 10px;
    --shadow-1: 0 1px 6px rgba(0,0,0,.06);
    --shadow-2: 0 4px 14px rgba(0,0,0,.08);
  }
  
  /* Layout */
  .invoices-view { background: var(--bg); min-height: 100%; }
  
  /* Top bar */
  .nav-bar-operations {
    position: fixed; top: 0; left: 0; width: 100%; height: 56px;
    background: var(--brand); z-index: 1000; box-shadow: var(--shadow-1);
  }
  .logo-button {
    position: absolute; height: 80%;
    top: 50%; left: 50%; transform: translate(-50%, -50%);
    cursor: pointer; margin: 0;
  }
  .top-spacer { height: 56px; }
  
  /* Header */
  .panel-head {
    margin: 10px 10px 8px; padding: 6px 8px;
    display: flex; align-items: center; justify-content: space-between;
  }
  .panel-head h3 { margin: 0; font-size: 14px; color: var(--text); }
  .head-icon { width: 22px; height: 22px; opacity: .9; }
  
  /* Filters */
  .filters-card {
    margin: 0 10px 10px; background: var(--card);
    border: 1px solid var(--border); border-radius: 8px;
    box-shadow: var(--shadow-1); padding: 8px;
    display: grid; grid-template-columns: 1fr; gap: 6px; font-size: 12px;
  }
  .filters-card .row {
    display: grid;
    grid-template-columns: 140px 320px 22px 320px;
    align-items: center; gap: 4px; min-height: 28px;
  }
  .filters-card .row.actions { grid-template-columns: 1fr; margin-top: 2px; }
  .filters-card label { color: var(--text); font-size: 12px; white-space: nowrap; }
  .filters-card .sep { text-align: center; color: var(--muted); font-size: 11px; }
  .filters-card input[type="text"],
  .filters-card input[type="date"],
  .filters-card select {
    height: 26px; padding: 0 8px; border: 1px solid #d2d2d2;
    border-radius: var(--radius-sm); font-size: 12px; outline: none; background: #fff;
  }
  .filters-card input::placeholder { color: #9aa0a6; font-size: 11px; }
  .filters-card input:focus,
  .filters-card select:focus { border-color: #bbb; box-shadow: 0 0 0 2px rgba(255,196,52,.22); }
  
  .row-rel { position: relative; }
  .suggestions {
    position: absolute; top: calc(26px + 4px); left: 140px; width: 320px;
    max-height: 220px; overflow-y: auto; background: #fff;
    border: 1px solid var(--border); border-radius: 8px; box-shadow: var(--shadow-2);
    list-style: none; margin: 0; padding: 4px 0; z-index: 10;
  }
  .suggestions li { padding: 6px 10px; font-size: 12px; cursor: pointer; }
  .suggestions li:hover { background: #f2f6ff; }
  
  /* Buttons */
  .btn-primary {
    padding: 6px 12px; font-size: 12px; border-radius: 8px;
    background: var(--brand); border: none; cursor: pointer; box-shadow: var(--shadow-1);
  }
  .btn-primary:hover { background: var(--brand-600); }
  .grayed-out { background: #f2f2f2; color: #999; }
  
  /* Results */
  .results-card {
    margin: 0 10px 16px; background: var(--card);
    border: 1px solid var(--border); border-radius: 8px;
    box-shadow: var(--shadow-1); overflow: hidden;
  }
  .results-head { padding: 8px 10px; border-bottom: 1px solid var(--border); }
  .results-head h2 { font-size: 14px; margin: 0; color: var(--text); }
  
  /* Table */
  .table-scroll { overflow-x: auto; }
  .table {
    width: 100%; border-collapse: collapse; table-layout: fixed;
    font-size: 11px; line-height: 1.15;
  }
  .table thead th {
    position: sticky; top: 0; z-index: 1;
    background: #f5f6f8; color: #475163; font-weight: 600;
    border-bottom: 1px solid var(--border); padding: 6px 8px; white-space: nowrap;
  }
  .table tbody td {
    padding: 4px 6px; border-bottom: 1px solid #f0f0f0;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .table tbody tr:nth-child(even) td { background: #fcfcfd; }
  .table tbody tr:hover td { background: #eef3ff; color: #0f172a; }
  
  /* Column sizing (prevent horizontal scroll) */
  .table td:nth-child(1) { width: 110px; } /* ID */
  .table td:nth-child(2) { width: 120px; } /* Fecha */
  .table td:nth-child(3) { width: 200px; } /* Cliente */
  .table td:nth-child(4) { width: 90px;  } /* OT */
  .table td:nth-child(5) { width: 110px; } /* Importe */
  .table td:nth-child(6) { width: 110px; } /* Saldo */
  .table td:nth-child(7) { width: 110px; } /* Status */
  .table td:nth-child(8) { width: 110px; } /* Archivos */
  
  .col-client { max-width: 200px; }
  .col-ot { text-align: left; }
  .col-money { text-align: left; }
  
  /* Badges */
  .badge {
    display: inline-block; padding: 2px 8px;
    border-radius: var(--radius-sm); font-size: 11px; line-height: 1.3;
    border: 1px solid transparent;
  }
  .badge-id { background: var(--brand); color: #000; font-weight: 700; border: 1px solid #f0c35a; }
  .badge-success { background: var(--success); color: #fff; }
  .badge-danger  { background: var(--danger); color: #fff; }
  .badge-warn    { background: var(--warn); color: #111; }
  
  /* Files buttons */
  .icon-btn {
    background: none; border: none; cursor: pointer; padding: 0 4px; font-size: 16px;
  }
  
  /* Pagination */
  .pagination {
    display: flex; flex-wrap: wrap; justify-content: center; align-items: center;
    gap: 6px; padding: 10px; border-top: 1px solid var(--border);
  }
  .pg-btn {
    background: #fff; border: 1px solid var(--border); border-radius: 8px; padding: 2px 6px;
    cursor: pointer; box-shadow: var(--shadow-1);
  }
  .pg-btn:disabled { opacity: .5; cursor: not-allowed; }
  .pg-btn img { width: 18px; height: auto; display: block; }
  .pg-num {
    min-width: 28px; text-align: center; padding: 4px 8px; border-radius: 8px;
    border: 1px solid var(--border); background: #fff; cursor: pointer; user-select: none;
  }
  .pg-num.active { background: var(--brand); border-color: #e0b12b; }
  
  /* Popup (kept your palette) */
  .popup-overlay {
    position: fixed; inset: 0; background: rgba(0,0,0,.4);
    display: flex; align-items: center; justify-content: center; z-index: 1200;
  }
  .popup-content {
    width: min(640px, 92vw); background: #fff; border-radius: 10px; padding: 16px;
    box-shadow: var(--shadow-2);
  }
  .popup-header { margin-bottom: 8px; }
  .popup-body { margin-top: 6px; }
  .popup-close-button {
    background-color: var(--brand); border: none; padding: 10px 16px; cursor: pointer;
    margin-top: 12px; color: #000; font-weight: bold; border-radius: 8px; margin-left: 10px;
  }
  
  /* Responsive compression */
  @media (max-width: 1200px) {
    .filters-card .row { grid-template-columns: 120px minmax(180px,1fr) 18px minmax(180px,1fr); }
    .table { font-size: 10.5px; }
  }
  @media (max-width: 900px) {
    .filters-card .row { grid-template-columns: 120px 1fr; }
    .filters-card .sep, .filters-card .row > .cell { display: none; }
    .suggestions { left: 0; width: 100%; }
  }

  .col-money { 
  text-align: right; 
  font-variant-numeric: tabular-nums; /* crisp column alignment */
}

.table thead th:nth-child(5),
.table thead th:nth-child(6) {
  text-align: right;
}

.no-access {
  text-align: center;
  padding: 18px 12px;
  color: #8a3b00;
  background: #fff6e5;
  border: 1px solid #f2dfb2;
  border-radius: 10px;
  margin-bottom: 12px;
}
  </style>
  